import "./calendar.css";
import { useEffect, useState, useCallback } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useDispatch, useSelector } from "react-redux";
import { Col } from "react-bootstrap";
import CheckInOut from "../../pages/EmployeeManagement/AttendanceDetails/CheckInOut";
import { employeeIndividualAttendancePath } from "../../services/config";
import {
  commonSaveData,
  initCommonState,
} from "../../redux/slices/commonSlice";
import { HasPermission } from "../../services/hasPermission";

const AttendanceCalendar = ({ userId, staffId, handleState }) => {
  const dispatch = useDispatch();
  const { commonData, commonSuccess } = useSelector((state) => state.common);

  // 🔥 Format date helper
  const formatDate = (date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")}`;

  const [value, setValue] = useState(new Date());

  // const [isAnotherMonth, setIsAnotherMonth] = useState(false);
  const [selectedDate, setSelectedDate] = useState(formatDate(new Date()));
  const [attendanceData, setAttendanceData] = useState([]);
  const [attendanceDetail, setAttendanceDetail] = useState([]);

  const fetchDates = useCallback(
    (monthStartDate) => {
      const data = {
        path: employeeIndividualAttendancePath,
        data: { selectedDate: monthStartDate, staffId, userId },
      };
      dispatch(commonSaveData(data));
    },
    [dispatch, staffId, userId]
  );

  useEffect(() => {
    const monthStartDate = formatDate(new Date());
    fetchDates(monthStartDate);
  }, []);

  useEffect(() => {
    if (commonSuccess && commonData?.allDates) {
      setAttendanceData(commonData.allDates);
      handleState(commonData.allDates);
      const selectedDateStr = selectedDate;
      const detail =
        commonData.allDates.find((item) => item.dates === selectedDateStr) ||
        null;
      setAttendanceDetail(detail);
      dispatch(initCommonState());
    }
  }, [commonSuccess, commonData, selectedDate, handleState, dispatch]);

  const handleMonthSelection = (event) => {
    setValue(event);
    // setIsAnotherMonth(true);
    const d = new Date(event);
    const formattedDate = formatDate(d);
    setSelectedDate(formattedDate);
    fetchDates(formattedDate);
  };

  const handleDateSelection = (event) => {
    setValue(event);
    const d = new Date(event);
    const formattedDate = formatDate(d);
    const newArr = attendanceData.filter((item) => item.dates == formattedDate);
    setAttendanceDetail(newArr[0]);
  };

  const tileClassName = ({ date, view }) => {
    if (view === "month") {
      const isSameMonth =
        date.getMonth() + 1 === value.getMonth() + 1 &&
        date.getFullYear() === value.getFullYear();
      const dateStr = formatDate(date);
      const match = attendanceData.find((item) => item.dates === dateStr);

      if (isSameMonth) {
        return match
          ? `dot-${match?.statusCode} highlight-current-month`
          : "highlight-current-month";
      } else {
        return `dot-${match?.status} highlight-other-month`;
      }
    }
    return null;
  };

  return (
    <>
      <Col sm="6">
        <div className="calendar-wrapper shadow light_border">
          <Calendar
            onChange={handleDateSelection}
            onActiveStartDateChange={({ activeStartDate }) =>
              handleMonthSelection(activeStartDate)
            }
            value={value}
            tileClassName={tileClassName}
            calendarType="gregory"
          />
          <div className="legend">
            <div className="legend-in">
              <span className="dot present"></span> Present
            </div>
            <div className="legend-in">
              <span className="dot absent"></span> Absent
            </div>
            <div className="legend-in">
              <span className="dot halfday"></span> Half Day
            </div>
            <div className="legend-in">
              <span className="dot double"></span> Double Present
            </div>

            <div className="legend-in">
              <span className="dot holiday"></span> Holiday
            </div>
            <div className="legend-in">
              <span className="dot weekoff"></span> Week Off
            </div>
          </div>
        </div>
      </Col>

      <Col sm="6">
        <CheckInOut attendanceDetail={attendanceDetail} />
      </Col>
    </>
  );
};

export default AttendanceCalendar;
